// extracted by mini-css-extract-plugin
module.exports = {"long":"_1DU80TzpF-9ym7d0n43oFV","default":"_15O7Vv9iyCLCftg4TUWk8","short":"_3kursBlYT4vHjqzkAfHDgA"};